import { Theme } from 'theme-ui';

import variants from './variants';
import sizes from './sizes';
import colors from './colors';
import styles from './styles';

const breakpoints = ['640px', '768px', '1024px', '1280px'];

const theme: Readonly<Theme> = {
  fonts: {
    body: `apercu, Roboto, system-ui, "Segoe UI", "Helvetica Neue", sans-serif`,
    heading: `apercu, Roboto, system-ui, "Segoe UI", "Helvetica Neue", sans-serif`,
    mono: `apercu-mono, Roboto Mono, system-ui, "Segoe UI", "Helvetica Neue", sans-serif`,
  },
  colors,
  breakpoints,
  sizes,
  ...variants,
  styles,
};

export default theme;

